// src/components/MyLineChart.tsx

import { Box, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import React from "react";
import useStyles from "./styles";
import FiberManualRecordRoundedIcon from "@mui/icons-material/FiberManualRecordRounded";
import { colorSchemes } from "@nivo/colors";
import handleColors from "../utils/handleColors";
import TooltipMui from "../../tooltipMui";
import { MyLinearDashConfig } from "./types";
import maskUnits from "../../../utils/maskUnits";
const formatSeries = (data: MyDatum[], indexBy: string, keys: string[]) =>
  data.map((item) => ({
    label: item[indexBy],
    value: Number(item[keys[0]]),
  }));

const LinearChart: React.FC<MyLinearDashConfig> = (props) => {
  const { data, orientation, units, fractionDigits, keys, indexBy } = props;
  const formattedData =
    keys && keys.length > 0 ? formatSeries(data, indexBy, keys) : [];

  const theme = useTheme();
  const styles = useStyles(theme);
  const colors = colorSchemes.nivo;
  const colorCustom = props.colorsByKey;
  const valueTotal = formattedData.reduce(
    (acc: number, item) =>
      acc + (typeof item.value === "number" ? item.value : 0),
    0
  );

  return (
    <Stack
      direction={orientation === "vertical" ? "row" : "column-reverse"}
      gap={3}
      sx={styles.container}
    >
      <Stack
        gap={0.5}
        direction={orientation === "vertical" ? "column" : "row"}
      >
        {formattedData.map((row, i) => (
          <TooltipMui
            key={`tooltip-${row.label}`}
            color={
              props?.colorsByKey
                ? handleColors(row.label, theme, props.colorsByKey)
                : colors[i]
            }
            valueX={row.label}
            valueY={maskUnits(row.value, units)}
            // valueZ={((Number(row.value) / valueTotal) * 100).toFixed(2) + "%"}
            valueZ={maskUnits(row.value / valueTotal, "%")}
          >
            <Box
              key={i}
              sx={styles.bar(
                typeof row.value === "number" ? row.value : 0,
                valueTotal,
                props?.colorsByKey
                  ? handleColors(row.label, theme, props.colorsByKey)
                  : colors[i],
                orientation
              )}
            />
          </TooltipMui>
        ))}
      </Stack>
      <Stack
        gap={2}
        sx={{ overflow: "auto", justifyContent: "space-between" }}
        direction={orientation === "vertical" ? "column" : "row"}
      >
        {formattedData.map((row, i) => (
          <Stack key={`legend-${row.label}`} direction="row" gap={1}>
            <FiberManualRecordRoundedIcon
              sx={styles.icon(
                props?.colorsByKey
                  ? handleColors(row.label, theme, props.colorsByKey)
                  : colors[i]
              )}
            />
            <Stack direction="column" alignItems="start" mt={-0.3}>
              <Typography sx={styles.label}>{row.label}</Typography>
              <Typography sx={styles.value}>
                {maskUnits(row.value, units, fractionDigits)}
              </Typography>
            </Stack>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default LinearChart;
